var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.462 11.3338L5.85205 9.99316V19.8994C5.85196 20.007 5.87312 20.1136 5.91433 20.2131C5.95553 20.3126 6.01596 20.403 6.09216 20.479C6.16836 20.5551 6.25882 20.6154 6.35836 20.6564C6.45791 20.6975 6.56457 20.7184 6.67224 20.7182H19.8035C19.9113 20.7186 20.0181 20.6978 20.1178 20.6568C20.2175 20.6159 20.3081 20.5556 20.3845 20.4795C20.4608 20.4034 20.5214 20.313 20.5626 20.2134C20.6039 20.1139 20.6251 20.0071 20.6251 19.8994V16.2494L13.462 11.3338Z",
    fill: "#185C37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.462 2.84278H6.67224C6.56457 2.8425 6.45791 2.86349 6.35836 2.90452C6.25882 2.94556 6.16836 3.00584 6.09216 3.08191C6.01596 3.15798 5.95553 3.24834 5.91433 3.34782C5.87312 3.44729 5.85196 3.55392 5.85205 3.66159V7.31153L13.462 11.7803L17.4914 13.1209L20.6251 11.7803V7.31153L13.462 2.84278Z",
    fill: "#21A366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85205 7.31152H13.462V11.7803H5.85205V7.31152Z",
    fill: "#107C41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M11.2984 6.41797H5.85205V17.5898H11.2984C11.5154 17.5888 11.7233 17.5022 11.877 17.349C12.0306 17.1957 12.1177 16.988 12.1193 16.771V7.23678C12.1177 7.01976 12.0306 6.81213 11.877 6.65886C11.7233 6.5056 11.5154 6.41905 11.2984 6.41797Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.8509 6.86426H5.85205V18.0361H10.8509C11.0679 18.0351 11.2757 17.9485 11.4294 17.7952C11.583 17.642 11.6701 17.4343 11.6717 17.2173V7.68307C11.6701 7.46605 11.583 7.25842 11.4294 7.10515C11.2757 6.95189 11.0679 6.86534 10.8509 6.86426Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.8509 6.86426H5.85205V17.1424H10.8509C11.0679 17.1413 11.2757 17.0548 11.4294 16.9015C11.583 16.7482 11.6701 16.5406 11.6717 16.3236V7.68307C11.6701 7.46605 11.583 7.25842 11.4294 7.10515C11.2757 6.95189 11.0679 6.86534 10.8509 6.86426Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.4033 6.86426H5.85205V17.1424H10.4033C10.6203 17.1413 10.8282 17.0548 10.9818 16.9015C11.1355 16.7482 11.2225 16.5406 11.2242 16.3236V7.68307C11.2225 7.46605 11.1355 7.25842 10.9818 7.10515C10.8282 6.95189 10.6203 6.86534 10.4033 6.86426Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19588 6.86426H10.4032C10.6207 6.86408 10.8292 6.95022 10.9832 7.10376C11.1371 7.2573 11.2238 7.46567 11.2241 7.68307V15.8767C11.2238 16.0941 11.1371 16.3025 10.9832 16.456C10.8292 16.6096 10.6207 16.6957 10.4032 16.6955H2.19588C2.08815 16.6959 1.98141 16.675 1.88179 16.634C1.78217 16.593 1.69162 16.5327 1.61535 16.4566C1.53908 16.3805 1.47859 16.2901 1.43734 16.1906C1.39609 16.0911 1.37491 15.9844 1.375 15.8767V7.68307C1.37491 7.57535 1.39609 7.46866 1.43734 7.36914C1.47859 7.26963 1.53908 7.17923 1.61535 7.10315C1.69162 7.02707 1.78217 6.96681 1.88179 6.92581C1.98141 6.88482 2.08815 6.8639 2.19588 6.86426Z",
    fill: "url(#paint0_linear_2057_91072)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91895 14.4426L5.64526 11.7723L4.06401 9.11719H5.33382L6.19663 10.8174C6.27638 10.9782 6.33413 11.0979 6.36026 11.1776H6.37195C6.42832 11.0488 6.4879 10.9237 6.5507 10.8022L7.47332 9.11994H8.64207L7.02026 11.7599L8.68332 14.4446H7.43963L6.44276 12.5808C6.3966 12.5006 6.35728 12.4167 6.3252 12.3299H6.3087C6.27956 12.4145 6.24081 12.4954 6.1932 12.5712L5.16676 14.4426H3.91895Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8041 2.84278H13.4619V7.31153H20.625V3.66159C20.6251 3.55386 20.6039 3.44718 20.5626 3.34766C20.5214 3.24814 20.4609 3.15775 20.3846 3.08167C20.3084 3.00559 20.2178 2.94532 20.1182 2.90433C20.0186 2.86333 19.9118 2.84242 19.8041 2.84278Z",
    fill: "#33C481"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4619 11.7803H20.625V16.249H13.4619V11.7803Z",
    fill: "#107C41"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2057_91072",
    x1: 3.08962,
    y1: 6.22076,
    x2: 9.5095,
    y2: 17.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelPic);
export default __webpack_public_path__ + "static/media/excel_pic.ecc427184bed67978a139abef4d9b8d8.svg";
export { ForwardRef as ReactComponent };